import React from 'react';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT, STATIC_ROOT } from '../../../constants';

import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import DownloadBlock from './DownloadBlock';
import SvgComponent from '../../SvgComponent';
import HeadComponent from '../../HeadComponent';
import Breadcrumb from '../../breadcrumb/Breadcrumb';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';

import './ToolbarPage.scss';

export class ToolbarPage extends React.Component {
    render() {
        const { i18n } = this.props;
        return (
            <main role="main" className="conteneur conteneur-mobile" id="p-toolbar">
                <HeadComponent
                    title={i18n.TITLE}
                    description={i18n.DESCRIPTION}
                    canonicalLink={`${CONTEXT_ROOT}${PATH.TOOLBAR_PATH}`}
                />
                <Breadcrumb
                    defaultRoute
                    routes={[
                        {
                            label: i18n.BREADCRUMB,
                            route: PATH.TOOLBAR_PATH
                        }
                    ]}
                />
                <h1>{i18n.PAGE_TITLE}</h1>

                <div className="bloc-toolbar">
                    <div className="explaination">
                        <p>{convertHtmlToReactDomWithParams(i18n.TEXT1)}</p>
                        <p>{i18n.TEXT2}</p>
                        <DownloadBlock />
                    </div>
                    <img
                        src={`${STATIC_ROOT}/toolbar/toolbar_visuel.png`}
                        className="visuel"
                        width="426"
                        height="297"
                        alt=""
                        aria-hidden="true"
                    />
                </div>

                <h3 className="sectionTitle">{i18n.SECTION_TITLE}</h3>
                <div className="explanationContainer">
                    <div className="explanationBloc">
                        <SvgComponent
                            src={`${STATIC_ROOT}/toolbar/tb-ccm1.svg`}
                            width="69"
                            height="69"
                            aria-hidden="true"
                            focusable="false"
                        />
                        <p>{convertHtmlToReactDomWithParams(i18n.TEXT3)}</p>
                    </div>
                    <div className="explanationBloc">
                        <SvgComponent
                            src={`${STATIC_ROOT}/toolbar/tb-ccm2.svg`}
                            width="69"
                            height="69"
                            aria-hidden="true"
                            focusable="false"
                        />
                        <p>{convertHtmlToReactDomWithParams(i18n.TEXT4)}</p>
                    </div>
                    <div className="explanationBloc">
                        <SvgComponent
                            src={`${STATIC_ROOT}/toolbar/tb-ccm3.svg`}
                            width="69"
                            height="69"
                            aria-hidden="true"
                            focusable="false"
                        />
                        <p>{convertHtmlToReactDomWithParams(i18n.TEXT5)}</p>
                    </div>
                </div>

                <div className="DownloadBloc">
                    <h3>{convertHtmlToReactDomWithParams(i18n.TEXT6)}</h3>
                    <p>{i18n.TEXT7}</p>
                    <DownloadBlock />
                </div>

                <div className="footer">
                    <img
                        src={`${STATIC_ROOT}/toolbar/toolbar-footer.png`}
                        width="1014"
                        height="341"
                        alt=""
                        aria-hidden="true"
                    />
                    <p>{i18n.FOOTER_TEXT}</p>
                </div>
            </main>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.TOOLBAR
    };
};

export default withTemplate(connect(mapStateToProps)(ToolbarPage), PrimaryTemplate);



// WEBPACK FOOTER //
// ./src/components/pages/toolbar/ToolbarPage.js